import React from 'react';
import { AppProvider, useApp } from './appContext';
import AppShell from './components/AppShell';
import SplashScreen from './components/SplashScreen';
import AuditMenu from './features/audit/AuditMenu';
import InspectionForm from './features/audit/InspectionForm';
import DashboardPage from './features/dashboard/DashboardPage';
import './index.css';

function AppContent() {
  const { currentPage } = useApp();

  return (
    <>
      <SplashScreen />
      <AppShell>
        {currentPage === 'audit-menu' && <AuditMenu />}
        {currentPage === 'inspection-form' && <InspectionForm />}
        {currentPage === 'dashboard' && <DashboardPage />}
      </AppShell>
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}
